<template>
    <div class="page article-detail">
        <article-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></article-detail-skeleton>

        <div v-else>
            <div class="article-detail-box">
                <h3 class="article-detail-title">{{ article.title }}</h3>

                <div style="padding: 0 15px 15px">
                    <div class="article-detail-time">{{ article.created_at }} 阅读 {{ article.view_count }}</div>
                </div>

                <div class="article-detail-option" v-if="article && article.parent !== null">
                    <img :src="article.parent.logo" alt="" class="article-detail-option-portrait" />
                    <div class="article-detail-option-content">
                        <div v-if="article.parent.title">
                            {{ article.parent.title.length > 10 ? article.parent.title.slice(0, 10) + '...' : article.parent.title }}
                        </div>
                        <div v-if="article.parent && article.parent.desc">
                            {{ article.parent.desc }}
                        </div>
                    </div>

                    <van-button type="primary" v-if="!article.parent.is_subscribe" @click="handleStatus(article)">
                        <img src="@/assets/medical/medical-follow.svg" />
                        关注
                    </van-button>
                    <van-button v-else @click="handleStatus(article)">
                        <img src="@/assets/medical/medical-follow.svg" />
                        已关注
                    </van-button>
                </div>
                <div class="clear" style="margin-top: 15px"></div>

                <div>
                    <div class="article-detail-content">
                        <div class="rich_media_inner" v-html="article.content"></div>
                    </div>
                </div>
            </div>

            <div class="article-detail-banner" v-if="article.product">
                <img :src="article.product.cover_img" @click="goProduct(article.product)" />
            </div>
            <div class="line"></div>
            <div class="article-detail-recommend" v-if="article.recommend && article.recommend.length">
                <div class="article-detail-recommend-title">
                    相关推荐
                </div>
                <div class="article-detail-recommend-list">
                    <div v-for="(item, index) in article.recommend" :key="item.id">
                        <!-- <Article :dataItem="item" :wapperFn="true" @goDetail="goDetail(item)" /> -->
                        <Article :dataItem="item" />
                        <van-divider v-if="index !== article.recommend.length - 1" />
                    </div>
                </div>
            </div>
            <div class="line"></div>

            <div class="comment" style="margin-top: 10px">
                <div class="comment-title">评论</div>
                <div class="comment-section" v-for="item in comment" :key="item.id">
                    <div class="comment-section-photo">
                        <img :src="item.avatar" alt="" />
                    </div>
                    <div class="comment-section-content">
                        <div class="comment-section-content-author" @click="reComment(item)">
                            {{ item.name }}
                            <img
                                v-if="item.top == 1"
                                src="/static/third/icon_top.svg"
                                alt=""
                                style="margin-left:4px;margin-bottom:-4px;background: #FDE0BD;border-radius: 4px"
                            />
                        </div>
                        <div class="comment-section-content-detail" @click="reComment(item)">{{ item.content }}</div>
                        <div class="comment-section-content-bottom">
                            <div class="comment-section-content-time">{{ item.created_at }}</div>
                            <div class="comment-section-content-point" @click="pointLikeComment(item)">
                                <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg"/></span>
                                <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg"/></span>
                                {{ item.like_count == 0 ? '赞' : item.like_count }}
                            </div>
                            <div class="clear"></div>
                            <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                                <div v-for="(valn, valIndex) in item.children" :key="valIndex">
                                    <span @click="reCommentChild(val)">{{ val.name }}</span>
                                    <span style="color: #404040" v-if="val.reply_name != ''">回复</span>
                                    <span @click="reCommentChild(val)">{{ val.reply_name }}</span>
                                    ：{{ val.content }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <div class="article-detail-footer">
                <!-- <img @click="openShareData" class="course-detail-share-button" src="/static/img/btn_share.svg" alt="" /> -->
                <div
                    class="new-live-detail-home-footer-content-text"
                    v-if="article && article.parent && article.parent.title"
                    @click="goParent(article.parent)"
                >
                    <van-image fit="cover" src="/static/img/course/icon_detail_tag_column.svg"></van-image>
                    <div>
                        {{ article.parent.title }}
                    </div>
                    <div><van-icon name="arrow" /></div>
                </div>
                <div class="article-detail-footer-box">
                    <div :class="'article-detail-footer-left ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-field
                            round
                            left-icon="/static/img/course/icon_course_text.svg"
                            v-model="comment_text"
                            :placeholder="comment_placeholder"
                        ></van-field>
                    </div>
                    <div :class="'article-detail-footer-right ' + (comment_text != '' ? 'comment_in' : '')">
                        <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                            <van-grid-item
                                icon="/static/img/course/icon_course_comment.svg"
                                text="评论"
                                @click="goComment"
                                :badge="comment.length > 0 ? comment.length : ''"
                            ></van-grid-item>
                            <van-grid-item
                                @click="favorite()"
                                v-if="article.isFavorite"
                                icon="/static/img/course/icon_course_favorite_on_20.svg"
                                text="已收藏"
                            />
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏" />
                            <van-grid-item
                                v-if="article.isLike"
                                icon="/static/two/icon_course_like_on.svg"
                                @click="pointLike()"
                                text="已点赞"
                                :badge="article.like_count > 0 ? article.like_count : ''"
                            ></van-grid-item>
                            <van-grid-item
                                v-else
                                icon="/static/two/icon_course_like_off.svg"
                                @click="pointLike()"
                                text="点赞"
                                :badge="article.like_count > 0 ? article.like_count : ''"
                            ></van-grid-item>
                        </van-grid>
                        <div class="article-detail-footer-right-btn" v-else>
                            <van-button type="danger" size="medium" @click="createComment" color="#D3172E">
                                发送
                            </van-button>
                        </div>
                    </div>
                </div>
                <van-number-keyboard safe-area-inset-bottom />
            </div>

            <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
                <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="" />
                <div class="share-img">
                    <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="" />
                </div>
                <div class="share-cancel-btn" @click="showShareDialog = false">
                    <img src="/static/img/course/icon_course_share_close.svg" alt="" />
                </div>
            </van-dialog>

            <van-dialog class="content" v-model="needPassword" :show-confirm-button="false">
                <template slot="title">
                    本篇内容需要您输入观看密码
                </template>
                <div class="cancel_otp_code_box">
                    <div class="otpInputs">
                        <input v-enterfocus ref="otpInputs" type="number" value="12" v-model="code" @keydown.delete="changeCode" />
                        <span class="code_list">{{ code1 }}</span>
                        <span class="code_list">{{ code2 }}</span>
                        <span class="code_list">{{ code3 }}</span>
                        <span class="code_list last_code_list">{{ code4 }}</span>
                    </div>
                    <p class="error_text" :class="{ show: error }">密码错误请重试</p>
                </div>
                <div class="content-footer">
                    <van-button style="width: 50%" type="danger" round @click="checkPassword(2)" color="#D3172E">
                        点击验证
                    </van-button>
                </div>
            </van-dialog>

            <!-- 新增的返回按钮 -->
            <BackFn></BackFn>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import articleDetailSkeleton from '@/skeleton/articleDetailSkeleton'
import verify from '../../../mixins/verify'
import BackFn from '../components/back.vue'
import Article from './article.vue'
export default {
    name: 'article-detail',
    mixins: [verify],
    components: {
        'article-detail-skeleton': articleDetailSkeleton,
        BackFn,
        Article
    },
    watch: {
        async $route(to, from) {
            this.loading = false
            this.id = this.$route.params.id
            window.location.reload()
        }
    },
    data() {
        return {
            id: 0,
            value: '',
            active: '',
            category_id: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            article: {
                content: ''
            },
            comment: [],
            comment_text: '',
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            comment_id: 0,
            to_user_id: 0,
            comment_placeholder: '写评论',
            user_id: 0,
            content_type: 0,
            type: false,
            pageID: null
        }
    },
    methods: {
        goProduct(row) {
            if (row.link) {
                window.location.href = row.link
            }
        },
        handleStatus(row) {
            if (!row.parent.is_subscribe) {
                this.pageID = row.parent.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        goParent(row) {
            this.$router.push({
                name: 'medical-column-list',
                params: { id: row.id }
            })
        },
        fetch(scene) {
            if (scene === 'article') {
                Interface.getData('get', Interface.article.detail + '/' + this.id).then(res => {
                    res.data.content = res.data.content.replace(
                        /mmbiz.qpic.cn/g,
                        'byh-api.dr-gobroad.com/wechat_avatar/?host=mmbiz.qpic.cn&url=https://mmbiz.qpic.cn'
                    )
                    this.article = res.data

                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                    if (this.article) {
                        if (this.article.need_password === 1 && !this.article.isPasswordAuth) {
                            this.needPassword = true
                            return
                        }
                        Interface.getShareInfo(this, this.article.title, this.article.cover_img, this.article.desc, 30, this.id)
                        Interface.mFootPrint(this.id,30,0,'',0,this.article.title)
                    }
                })
            } else if (scene === 'comment') {
                let params = {
                    content_id: this.id,
                    comment_type: 2,
                    content_type: this.content_type,
                    page: 1,
                    pageSize: 999
                }
                Interface.getData('get', Interface.comment, params).then(res => {
                    if (res.code == 0) {
                        if (res.data.list) this.comment = res.data.list
                    }
                })
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 2,
                    content_type: this.content_type
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.htmlUrl = res.data.post_img_url
                })
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.fetch('article')
                    } else {
                        this.$toast(res.message)
                    }
                })
            }
        },
        changeCategory() {
            this.fetch('article')
        },
        favorite() {
            let params = {
                content_type: this.content_type
            }
            Interface.getData('get', Interface.article.favorite + '/' + this.id, params).then(res => {
                if (res.code == 0) {
                    this.article.isFavorite = !this.article.isFavorite
                }
            })
        },
        createComment() {
            if (this.comment_text == '') {
                return
            }

            if(!Interface.checkComplete(this)){
                return
            }

            let params = {
                content_id: this.id,
                comment_type: 2,
                content: this.comment_text,
                content_type: this.content_type
            }
            if (this.comment_id != 0) {
                params.comment_id = +this.comment_id
            }
            if (this.to_user_id != 0) {
                params.to_user_id = +this.to_user_id
            }
            Interface.getData('post', Interface.comment, params).then(res => {
                if (res.code == 0) {
                    this.$toast.success('发送成功')
                    this.fetch('comment')
                    this.goComment()
                    this.comment_text = ''
                    this.comment_placeholder = '写评论'
                    this.comment_id = 0
                    this.to_user_id = 0
                }
            })
        },
        reComment(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.id
        },
        reCommentChild(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.comment_id
            this.to_user_id = item.user_id
            console.log(item)
        },
        pointLike() {
            Interface.getData('get', Interface.article.point_like + this.id).then(res => {
                if (res.code == 0) {
                    this.article.isLike = !this.article.isLike
                    if (this.article.isLike) {
                        this.article.like_count += 1
                    } else {
                        this.article.like_count -= 1
                    }
                }
            })
        },
        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        goComment() {
            this.$el.querySelector('.comment').scrollIntoView()
        },
        openShareData() {
            this.showShareDialog = true
        }
    },
    created() {
        this.id = this.$route.params.id
        if (this.$route.query.content_type) {
            this.content_type = this.$route.query.content_type
        }
        this.fetch('article')
        this.fetch('comment')
        this.fetch('share')
        Interface.footPrint(2, this.id, this.content_type)
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(this.id, 30,'', '', source_type, this.article.title)
        }
    },
    deactivated() {
        this.fetch('article')
    }
}
</script>

<style lang="scss">
@import './index';
@import '../../../components/comment';
</style>



// WEBPACK FOOTER //
// src/views/medical-column/detail/index.vue